'use strict';

import { GLOBAL } from './Global';
import { SALES_AUTOMATION_V2 as SALES_AUTOMATION_V2_PERMISSION_GROUPS } from '../PermissionsGroups';

const sales_automation_v2_permissions_list = [];

for (const [key, value] of Object.entries(SALES_AUTOMATION_V2_PERMISSION_GROUPS)) {
  sales_automation_v2_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SALES_AUTOMATION_V2 = {
  can: [
    ...GLOBAL.can,
    ...sales_automation_v2_permissions_list,
  ],
};

export {
  SALES_AUTOMATION_V2,
};
